var exports = {
  "vK": "ChannelFollowModal.module__banner___YVB0bH",
  "Wp": "ChannelFollowModal.module__patternImage___YVB0bH",
  "JE": "ChannelFollowModal.module__bannerRow___YVB0bH",
  "QE": "ChannelFollowModal.module__sourceGuildIcon___YVB0bH",
  "AQ": "ChannelFollowModal.module__sourceChip___YVB0bH",
  "fS": "ChannelFollowModal.module__sourceChipIcon___YVB0bH",
  "jl": "ChannelFollowModal.module__sourceChipName___YVB0bH",
  "Qs": "ChannelFollowModal.module__content___YVB0bH",
  "Lv": "ChannelFollowModal.module__intro___YVB0bH",
  "DD": "ChannelFollowModal.module__title___YVB0bH",
  "h_": "ChannelFollowModal.module__description___YVB0bH",
  "aK": "ChannelFollowModal.module__hint___YVB0bH",
  "p$": "ChannelFollowModal.module__emptyState___YVB0bH",
  "By": "ChannelFollowModal.module__guildOption___YVB0bH",
  "XN": "ChannelFollowModal.module__guildAvatar___YVB0bH",
  "oM": "ChannelFollowModal.module__guildAvatarPlaceholder___YVB0bH",
  "ed": "ChannelFollowModal.module__optionLabel___YVB0bH",
  "TN": "ChannelFollowModal.module__channelOption___YVB0bH",
  "p": "ChannelFollowModal.module__channelIcon___YVB0bH",
  "yb": "ChannelFollowModal.module__categoryName___YVB0bH",
};

module.exports = exports;
